import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { AppSettingsStore } from './app-settings-store';
import { BrowserAppSettingsLoader } from './browser-app-settings-loader';
import { SERVER_APP_SETTINGS } from './server-app-settings.token';

@Injectable({ providedIn: 'root' })
export class AppSettingsInitializer {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly store = inject(AppSettingsStore);
  private readonly browserLoader = inject(BrowserAppSettingsLoader);
  private readonly serverSettings = inject(SERVER_APP_SETTINGS, { optional: true });

  async initialize(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      const settings = await this.browserLoader.load();
      this.store.set(settings);
      return;
    }

    if (!this.serverSettings) {
      throw new Error('SERVER_APP_SETTINGS was not provided during SSR.');
    }

    this.store.set(this.serverSettings);
  }
}
